import type { SourceLink } from '~/types/Candidates';

export interface ApiSourceLike {
  id: number;
  label: string;
  url: string;
}

// `url` is bound directly into `:href` throughout the app — guard against a
// `javascript:`-scheme payload (e.g. from a compromised or insufficiently
// validated CMS entry) being used as a click-to-execute XSS sink.
const SAFE_URL_SCHEMES = /^(https?:|mailto:)/i;

export function mapSourceLink(raw: ApiSourceLike): SourceLink {
  return {
    // Stable identity for `v-for` keys: `url` is blanked below for unsafe
    // schemes and `label` is not guaranteed unique, so neither is a safe key.
    id: String(raw.id),
    label: raw.label,
    url: SAFE_URL_SCHEMES.test(raw.url) ? raw.url : '',
  };
}
